
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OTPDelivery, OTPRequestData, OTPRequest } from 'app/model/tillotp';
import { ApprovalService } from '../approval.service';



@Component({
  selector: 'mifosx-approval-dialog',
  templateUrl: './approval-dialog.component.html',
  styleUrls: ['./approval-dialog.component.scss']
})
export class ApprovalDialogComponent implements OnInit {

  authenticationForm: FormGroup;

  showUserFields: boolean;
  showTokenMethodFields: boolean;
  showTokenFields: boolean;
  otpOPtions: Array<OTPDelivery>;
  otpData: OTPRequestData;
  refreshingToken: boolean = false;

  @ViewChild('confirmButton') confirmButton: ElementRef;

  constructor(public dialogRef: MatDialogRef<ApprovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OTPRequestData,
    private formBuilder: FormBuilder,
    private service: ApprovalService) { 
      this.otpData = data;

    }

  ngOnInit(): void {
    this.showUserFields = true;
    this.showTokenMethodFields = false;
    this.showTokenFields = false;
    this.createAuthForm();
  }


  createAuthForm(){
    this.authenticationForm = this.formBuilder.group({
      'username': ['',[Validators.required]],
      'password': ['', [Validators.required, Validators.maxLength(50), Validators.minLength(2)]],
      'tokenDelivery': ['',Validators.required],
      'token': ['',Validators.required]
    });

  }

  handleUserNameConfirmation(){
    if(this.authenticationForm.get('username').valid && this.authenticationForm.get('password').valid )
    {
      this.service.getTillOTPDeliveryMethod(this.authenticationForm.get('username').value)
      .subscribe(res => {
      
        this.showUserFields = false;
        this.showTokenMethodFields = true;
        this.otpOPtions = res;

      })
    }else{
      this.authenticationForm.get('username').markAsTouched();
      this.authenticationForm.get('password').markAsTouched();
    }
  }

  handleTokenMethodConfirmation(){

    if(this.authenticationForm.get('tokenDelivery').valid){
      const 
      tillOTPRequest: OTPRequest = {
        password: this.authenticationForm.get('password').value,
        requestAmount: this.otpData.requestAmount,
        requestEntityId: this.otpData.entityId,
        username: this.authenticationForm.get('username').value
        
      };

      const deliveryMethod = this.authenticationForm.get('tokenDelivery').value;
      this.refreshingToken = true;
      this.service.sendOTPToUser(deliveryMethod,tillOTPRequest)
      .subscribe(
        resp => {
          this.refreshingToken = false;
          this.showTokenMethodFields = false;
          this.showTokenFields = true;
        }
      );
    }else{
      this.authenticationForm.get('tokenDelivery').markAsTouched();
    }
  }

  handleTokenConfirmation(){
    if(this.authenticationForm.get('token').valid){
      const mToken = this.authenticationForm.get('token').value;
      this.dialogRef.close({
        'approvalToken':mToken,
        'approverUsername':  this.authenticationForm.get('username').value,
      })
    }else{
      this.authenticationForm.get('token').markAsTouched();
    }
  }

  handleConfirmButton(){

    if(this.showUserFields){
      this.handleUserNameConfirmation();
    }else if (this.showTokenMethodFields){
      this.handleTokenMethodConfirmation();
    }else if(this.showTokenFields){
      this.handleTokenConfirmation();
    }
    
  }

  handleCancelNavigation(){
    if(this.showUserFields){
      this.dialogRef.close();
    }else if(this.showTokenMethodFields){
      this.showTokenMethodFields = false;
      this.showUserFields = true;
    }else if(this.showTokenFields){
      this.showTokenFields = false;
      this.showTokenMethodFields = true;
    }
  }
}
